import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isSelectedCompanies: false,
    headernameForAggregate: '',
    saveFormulaeValues: {},
    rowID: '',
    screenerFolderName: '',
    ScreenerFolderNameCo: '',
    ScreenerFolderNameAPI: '',
    outputDataInRedux: [],
    commonScreenerFolderName: '',
    filterSecondTableData: [],
    subNodename: '',
    selectedFMTValue: ['GEN'],
    childValue: '',
    FnameValue: 'GEN',
    DFMTValue: 'GEN',
    ScreenerName: '',
    ScreenerAPIName: '',
    APILeftMenu: []
}

const checkboxSlice = createSlice({
    name: 'checkbox',
    initialState,
    reducers: {
        setIsSelectedCompanies(state, action) {
            state.isSelectedCompanies = action.payload;
        },
        setHeadernameForAggregate: (state, action) => {
            if (action.payload) {
                state.headernameForAggregate = action.payload;
            }
        },
        setSaveFormulaeValues: (state, action) => {
            state.saveFormulaeValues = action.payload;
        },
        setRowId: (state, action) => {
            state.rowID = action.payload;
        },
        setScreenerFolderName: (state, action) => {
            state.screenerFolderName = action.payload;
        },
        setScreenerFolderNameCo: (state, action) => {
            state.ScreenerFolderNameCo = action.payload;
        },
        setScreenerFolderNameAPI: (state, action) => {
            state.ScreenerFolderNameAPI = action.payload;
        },
        setOutputDataInRedux: (state, action) => {
            state.outputDataInRedux = action.payload;
        },
        setCommonScreenerFolderName: (state, action) => {
            state.commonScreenerFolderName = action.payload;
        },
        setFilterSecondTableData: (state, action) => {
            state.filterSecondTableData = action.payload;
        },
        setSubNodename: (state, action) => {
            state.subNodename = action.payload;
        },
        setSelectedFMTValue: (state, action) => {
            state.selectedFMTValue = action.payload;
        },
        setChildValue: (state, action) => {
            state.childValue = action.payload;
        },
        setFnameValue: (state, action) => {
            state.FnameValue = action.payload;
        },
        setScreenerName: (state, action) => {
            state.ScreenerName = action.payload;
        },
        setScreenerAPIName: (state, action) => {
            state.ScreenerAPIName = action.payload;
        },
        setAPILeftMenu: (state, action) => {
            state.APILeftMenu = action.payload;
        },
        setDFMTValue: (state, action) => {
            state.DFMTValue = action.payload;
        },
    },
});

export const { setIsSelectedCompanies, setHeadernameForAggregate, setSaveFormulaeValues, setRowId, setScreenerFolderName, setScreenerFolderNameCo, setScreenerFolderNameAPI, setOutputDataInRedux, setCommonScreenerFolderName, setFilterSecondTableData, setSubNodename, setSelectedFMTValue, setChildValue, setFnameValue, setScreenerName, setScreenerAPIName, setAPILeftMenu, setDFMTValue } = checkboxSlice.actions
export default checkboxSlice.reducer;

